import React from 'react';
/**
 * Pill-style mutually exclusive toggle (e.g. By Course / By Stroke, National / Regional / County).
 */
export function SegmentedToggle({ options, value, onChange, disabled, label, trailing, }) {
    return (React.createElement("div", { className: "segmented-toggle" },
        label && (React.createElement("span", { className: "filter-chip-label" }, label)),
        options.map(option => (React.createElement("button", { key: option.value, className: value === option.value ? 'active' : '', onClick: () => onChange(option.value), disabled: disabled }, option.label))),
        trailing));
}
export default SegmentedToggle;
